const rePhone = /^[+]?[(]?[1-9][0-9]{2}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3,6}$/im;
const reDate = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
const reEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const reVatNumber = /^[A-Z0-9]+$/;

export { reDate, rePhone, reEmail, reVatNumber };
